package hk.com.vr360_demo2.webapp.utils

import kotlinx.serialization.Serializable

@Serializable
data class Url(
    val pathSegments: List<String>,
    val parameters: Map<String, String>,
)

fun Url(url: String): Url {
    var path: String = url.substringAfter(delimiter = "://").substringAfter(delimiter = "/")
    var parameters: Map<String, String> = emptyMap()

    if ('?' in path) {
        parameters =
            path.substringAfter(delimiter = "?")
                .split("&")
                .map {
                    val parts = it.split("=", limit = 2)
                    val key = parts[0]
                    val value = if (parts.size > 1) parts[1] else ""
                    key to value
                }
                .associate { it }

        path = path.substringBefore(delimiter = "?")
    }

    return Url(pathSegments = path.split("/"), parameters = parameters)
}

fun Url.consumePathSegment(): Pair<String?, Url> =
    pathSegments.firstOrNull() to copy(pathSegments = pathSegments.drop(1))


internal fun Any.path(): String = this::class.simpleName?.snakeCase() ?: ""

internal inline fun <reified T : Any> pathSegmentOf(): String =
        T::class.simpleName?.snakeCase() ?: ""
